var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLTopnavTeamCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconL-topnav-team-circle",
    x: 0.448,
    y: 0.631,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconL-topnav-team-circle1",
    serifid: "iconL-topnav-team-circle",
    d: "M20.448,1.634c-10.486,-0 -19,8.513 -19,19c-0,10.486 8.514,19 19,19c10.486,-0 19,-8.514 19,-19c-0,-10.487 -8.514,-19 -19,-19Zm-15.472,26.337l-0.002,-0.004c-1.054,-2.221 -1.643,-4.713 -1.643,-7.333c-0,-9.448 7.67,-17.118 17.117,-17.118c9.447,0 17.117,7.67 17.117,17.118c0,3.239 -0.901,6.269 -2.467,8.853c-1.367,-1.555 -3.117,-2.78 -5.159,-3.548l0.02,0.004c-0,-0 -0.09,-0.068 -0.03,-0.106l0.027,-0.017c2.113,-1.42 3.504,-3.832 3.504,-6.569c-0,-4.367 -3.541,-7.908 -7.908,-7.908c-4.368,0 -7.908,3.541 -7.908,7.908c-0,2.737 1.391,5.15 3.533,6.587l-0.032,0.104l0.057,-0.056c-0,0.013 -0.055,0.055 -0.057,0.057l0.018,-0.003l-0.087,0.028c-1.307,0.494 -2.787,1.511 -4.004,2.687c-1.002,0.968 -1.792,2.049 -2.461,2.989l-0.001,0.002c-0.116,0.164 -0.184,0.363 -0.184,0.579c0,0.555 0.45,1.005 1.005,1.005c0.339,0 0.639,-0.168 0.823,-0.428c3.315,-3.776 4.886,-5.639 9.298,-5.639c3.375,0 6.384,1.566 8.36,4.037l-0.001,0c-3.135,3.988 -8.002,6.551 -13.463,6.551c-6.129,0 -11.539,-3.264 -14.563,-8.111c0.03,-0.044 0.054,-0.078 0.064,-0.093c0.226,-0.351 1.052,-1.372 1.065,-1.388l-0.001,0.001c1.798,-2.529 4.717,-4.159 8.017,-4.163l0.001,0c0.506,0 0.917,-0.41 0.917,-0.917c-0,-0.507 -0.411,-0.917 -0.918,-0.917c0,-0 0,-0 0,-0c-2.988,-0.004 -5.409,-2.427 -5.409,-5.416c-0,-2.991 2.424,-5.416 5.415,-5.416c0.523,0 1.175,0.086 1.507,0.213c0.131,0.05 0.358,0.139 0.515,0.189c0.06,0.019 0.108,0.032 0.133,0.032c0.505,0 0.819,-0.404 0.819,-0.909c0,-0.421 -0.34,-0.729 -0.677,-0.886c-0.501,-0.234 -1.316,-0.476 -2.304,-0.476c-4.003,0 -7.249,3.246 -7.249,7.25c-0,2.509 1.275,4.72 3.212,6.022l0.025,0.016l-0.003,0.011c0.005,0.011 0.005,0.024 0.001,0.037c-0.003,0.012 -0.01,0.022 -0.02,0.029l-0.008,0.028c0.007,0 0.014,-0.001 0.02,-0.004c-2.265,0.852 -4.138,2.314 -5.471,4.186c-0.014,0.021 -0.339,0.512 -0.56,0.902Zm20.564,-14.62c-3.255,0 -5.898,2.643 -5.898,5.898c-0,3.256 2.643,5.899 5.898,5.899c3.256,-0 5.899,-2.643 5.899,-5.899c-0,-3.255 -2.643,-5.898 -5.899,-5.898Z",
    style: {
      fill: "#808080"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLTopnavTeamCircle);
export default __webpack_public_path__ + "static/media/iconL-topnav-team-circle.a6d46a501782ce2abfe76d43f6767f30.svg";
export { ForwardRef as ReactComponent };